import React from 'react';
import { Router } from './router';
import { Analytics } from "@vercel/analytics/react"


const App: React.FC = () => {
    <Analytics />
  return <Router />;
};

export default App;
